'use-strict';

/* @ngInject */
export default function UserTableController(
  $scope,
  $location,
  NgTableParams,
  usersApiService,
  interfaceService,
  permissionsService,
) {
  const self = this;
  $scope.users = [];

  const updateTableData = (data) => {
    self.userTable.settings({
      dataset: data,
    });
    interfaceService.applyScope($scope);
  };

  const getUsers = () => {
    usersApiService.getUsersWithRoles()
      .then((users) => {
        $scope.users = users;
        updateTableData(users);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const init = () => {
    self.userTable = new NgTableParams();
    getUsers();
  };

  /**
   * Remove all applied filters from table
   */
  $scope.removeAllFilter = () => {
    self.userTable.filter({});
  };

  /**
   * Remove the supplied filter from the view's table.
   * @param {Object} filter
   */
  $scope.removeFilter = (filter) => {
    delete self.userTable.filter()[filter];
  };

  $scope.clickRow = (userId) => {
    if (!permissionsService.isPermitted([])) return;

    $location.path(`/settings/users/edit/${userId}`);
  };

  init();
}
